import { useParams } from "react-router-dom";
import SignUpForm from "./SignUp";
import LandingPage from "./LandingPage";
import PreferencePage from "./PreferencePage";
import OptOutPage from "./OptOutPage";
import UnsubscribePage from "./UnsubscribePage";

export default function LoadForm() {
  const { formId } = useParams<string>();

  let form = <></>

  switch (formId) {
    case "sign-up":
      form = <SignUpForm />
      break;
    case "thank-you":
      form = <LandingPage />
      break;
    case "preferences":
      form = <PreferencePage />
      break;
    case "opt-out":
      form = <OptOutPage />
      break;
    case "unsubscribe":
      form = <UnsubscribePage />
      break;
  }


  return (
    <div>
      {form}
    </div>
  );
}
